export type CornerPanelPosition =
  | 'bottom-right'
  | 'bottom-left'
  | 'top-right'
  | 'top-left';

export const cornerPanelAnimationClassNames: Record<
  CornerPanelPosition,
  string
> = {
  'bottom-right': 'corner-panel-animation corner-panel-animation-bottom-right',
  'bottom-left': 'corner-panel-animation corner-panel-animation-bottom-left',
  'top-right': 'corner-panel-animation corner-panel-animation-top-right',
  'top-left': 'corner-panel-animation corner-panel-animation-top-left',
};

export const getCornerPanelAnimationClassName = (
  position: CornerPanelPosition,
  animate: boolean
) => (animate ? cornerPanelAnimationClassNames[position] : null);

export const cornerPanelPositionClassNames: Record<
  CornerPanelPosition,
  string
> = {
  'bottom-right': 'bottom-6 right-6',
  'bottom-left': 'bottom-6 left-6',
  'top-right': 'top-6 right-6',
  'top-left': 'top-6 left-6',
};
